// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"50fdf399","115":"ff0d66d2","239":"0b4d17f5","496":"c6835fde","834":"bf531cf7","929":"0b4d17f5","948":"c6835fde"}[chunkId] + ".chunk.css";
};